// Each browser tab keeps the version of the request it loaded. A successful mutation
// advances only that tab; another tab must reload instead of overwriting newer facts.
export function installRequestFulfillmentVersion(api) {
    const versions = new Map();
    const requestId = url => {
        const match = String(url || '').match(/^\/api\/requests\/items\/(\d+)(?:\/|$)/);
        return match && match[1];
    };
    api.interceptors.request.use(config => {
        const id = requestId(config.url);
        if (id && versions.has(id) && /\/items\/\d+\/items(?:\/|$)/.test(config.url) && ['put', 'post', 'delete'].includes(config.method)) {
            config.data = {...(config.data || {}), fulfillment_version: versions.get(id)};
        }
        return config;
    });
    api.interceptors.response.use(response => {
        const id = requestId(response.config.url);
        const data = response.data || {};
        if (id && response.config.method === 'get' && /^\/api\/requests\/items\/\d+$/.test(response.config.url)) {
            if (data.fulfillment) versions.set(id, data.fulfillment.itemsVersion);
            else versions.delete(id);
        } else if (id && data.fulfillment_version) versions.set(id, data.fulfillment_version);
        return response;
    });
}
